/**
* @file 运营中心-平台管理
* */
<template>
  <div id="settingFrame">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content" v-show="tabs.length > 0">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "settingFrame",
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.tabAction = to.path
  //   })
  // },
  data() {
    return {
      // tabs列表
      tabs: [],
      tabAction: null,
    };
  },
  computed: {
    ...mapGetters({'buttonsGetter': 'buttonsGetter'})
  },
  watch: {
    tabAction() {
      this.$router.push(this.tabAction);
    },
    $route: {
      handler(val) {

        if (val.path == '/driverFormBackup' || val.path == '/vehicleFormBackup') {
          this.tabAction = '/dataBackup';
        } else {

          if (val.path == '/settingFrame') {
            let tabs = [];

            if (this.menuPreFn(56)) tabs.push({label: "平台管理", name: "/platform", icon: 'el-icon-monitor'});
            if (this.menuPreFn(57)) tabs.push({label: "司机端管理", name: "/driverPort", icon: 'el-icon-user-solid'});
            if (this.menuPreFn(57)) tabs.push({label: "乘客端管理", name: "/passengerPort", icon: 'el-icon-s-custom'});
            if (this.menuPreFn(58)) tabs.push({label: "票务设置", name: "/ticketing", icon: 'el-icon-ticket'});
            if (this.menuPreFn(59)) tabs.push({label: "选座模板", name: "/seat", icon: 'el-icon-menu'});
            if (this.menuPreFn(60)) tabs.push({label: "协议管理", name: "/protocol", icon: 'el-icon-notebook-2'});
            if (this.menuPreFn(61)) tabs.push({label: "旅游包车", name: "/chartered", icon: 'el-icon-truck'});
            if (this.menuPreFn(62)) tabs.push({label: "下单区域限制", name: "/regionalRestrictions", icon: 'el-icon-location'});
            if (this.menuPreFn(63)) tabs.push({label: "敏感人员数据", name: "/sensitivePersonnel", icon: 'el-icon-warning'});
            if (this.menuPreFn(64)) tabs.push({label: "安检模板管理", name: "/securityTemplate", icon: 'el-icon-s-check'});
            if (this.menuPreFn(43)) tabs.push({label: "司机端通知", name: "/notification", icon: 'el-icon-bell'});
            if (this.menuPreFn(39)) tabs.push({label: "培训计划", name: "/training", icon: 'el-icon-reading'});
            if (this.menuPreFn(79)) tabs.push({label: "结算设置", name: "/orderStationSettle", icon: 'el-icon-money'});
            if (this.menuPreFn(83)) tabs.push({label: "移动端管理", name: "/stationReferrerConfig", icon: 'el-icon-mobile-phone'});
            this.tabs = tabs;
            // this.tabAction = tabs[0].name

            this.tabAction = this.tabAction ?this.tabAction : tabs[0].name
            this.$router.push(this.tabAction);
            return
          }
          this.tabAction = val.path;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    this.mixinOrganizations();
    let tabs = [];
    setTimeout(() => {

      if (this.menuPreFn(56)) tabs.push({label: "平台管理", name: "/platform", icon: 'el-icon-monitor'});
      if (this.menuPreFn(57)) tabs.push({label: "司机端管理", name: "/driverPort", icon: 'el-icon-user-solid'});
      if (this.menuPreFn(57)) tabs.push({label: "乘客端管理", name: "/passengerPort", icon: 'el-icon-s-custom'});
      if (this.menuPreFn(58)) tabs.push({label: "票务设置", name: "/ticketing", icon: 'el-icon-ticket'});
      if (this.menuPreFn(59)) tabs.push({label: "选座模板", name: "/seat", icon: 'el-icon-menu'});
      if (this.menuPreFn(60)) tabs.push({label: "协议管理", name: "/protocol", icon: 'el-icon-notebook-2'});
      if (this.menuPreFn(61)) tabs.push({label: "旅游包车", name: "/chartered", icon: 'el-icon-truck'});
      if (this.menuPreFn(62)) tabs.push({label: "下单区域限制", name: "/regionalRestrictions", icon: 'el-icon-location'});
      if (this.menuPreFn(63)) tabs.push({label: "敏感人员数据", name: "/sensitivePersonnel", icon: 'el-icon-warning'});
      if (this.menuPreFn(64)) tabs.push({label: "安检模板管理", name: "/securityTemplate", icon: 'el-icon-s-check'});
      if (this.menuPreFn(43)) tabs.push({label: "司机端通知", name: "/notification", icon: 'el-icon-bell'});
      if (this.menuPreFn(39)) tabs.push({label: "培训计划", name: "/training", icon: 'el-icon-reading'});
      if (this.menuPreFn(79)) tabs.push({label: "结算设置", name: "/orderStationSettle", icon: 'el-icon-money'});
      if (this.menuPreFn(83)) tabs.push({label: "移动端管理", name: "/stationReferrerConfig", icon: 'el-icon-mobile-phone'});
      this.tabs = tabs;
      console.log(this.tabAction, this.tabs,2323323231111111111111);
      // this.tabAction = tabs[0].name

      this.tabAction = this.tabAction && this.tabAction != '/settingFrame' ? this.tabAction : tabs[0].name;
    }, Object.values(this.buttonsGetter ? this.buttonsGetter : {}).length > 0 ? 0 : 1500);
  },
};
</script>

<style lang="less">
#settingFrame {
  height: 100%;

  .el-tabs--card {
    .el-tabs__header {
      margin-bottom: 0;
      border-bottom: none;
    }
    
    .el-tabs__nav {
      border: none;
    }
    
    .el-tabs__item {
      border: none;
      border-radius: 6px 6px 0 0;
      margin-right: 4px;
      transition: all 0.2s;
      
      &.is-active {
        background: #fff;
        color: #2B77FF;
        font-weight: 500;
      }
      
      &:hover:not(.is-active) {
        color: #2B77FF;
      }
    }
  }

  .content {
    height: calc(100% - 40px);
    background: #fff;
    border-radius: 0 8px 8px 8px;
    padding: 0 20px;
    overflow-y: auto;

    & > div {
      height: 100%;
    }
  }
}
</style>
